import React from "react";
import axios from "axios";
import { setZona, zona } from "@/lib/waktu";

// G3-0: empty = API on the same domain ("/api", production behind Nginx)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// Owner 2026-10-08: load the business time zone (Pengaturan → Zona waktu) once
// for every page; when it differs from the default (WIT) the pages are drawn
// again with it.
export default function ZonaWaktu({ children }) {
  const [z, setZ] = React.useState(zona());
  React.useEffect(() => {
    let alive = true;
    axios.get(`${BACKEND_URL}/api/public/zona`)
      .then((r) => alive && r.data?.zona_waktu && setZ(setZona(r.data.zona_waktu)))
      .catch(() => {});  // offline: keep WIT
    return () => { alive = false; };
  }, []);
  return <React.Fragment key={z}>{children}</React.Fragment>;
}
